import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // Import thêm Autoplay
import "swiper/css";
import "swiper/css/pagination";
import "./ScheduleSection.css";

const scheduleData = [
  {
    id: "lich1",
    image: "/images/home/schedule/schedule1.webp",
    alt: "Khai giảng 1",
  },
  {
    id: "lich2",
    image: "/images/home/schedule/schedule2.webp",
    alt: "Khai giảng 2",
  },
  {
    id: "lich3",
    image: "/images/home/schedule/schedule3.webp",
    alt: "Khai giảng 3",
  },
  {
    id: "lich4",
    image: "/images/home/schedule/schedule4.webp",
    alt: "Khai giảng 4",
  },
  {
    id: "lich5",
    image: "/images/home/schedule/schedule5.webp",
    alt: "Khai giảng 5",
  },
  {
    id: "lich6",
    image: "/images/home/schedule/schedule6.webp",
    alt: "Khai giảng 6",
  },
  {
    id: "lich7",
    image: "/images/home/schedule/schedule7.webp",
    alt: "Khai giảng 7",
  },
];

const ScheduleSection = () => (
  <section className="schedule">
    <div className="schedule__container">
      <div className="schedule__icon">
        <FaCalendarAlt />
      </div>
      <h2 className="schedule__title">LỊCH KHAI GIẢNG</h2>

      <Swiper
        modules={[Pagination, Autoplay]}
        grabCursor={true}
        loop={true}
        allowTouchMove={true}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="schedule__swiper"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 5,
            centeredSlides: false,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 5,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 5,
            centeredSlides: true,
          },
        }}
      >
        {scheduleData.map(({ id, image, alt }) => (
          <SwiperSlide
            key={id}
            className="schedule__slide"
          >
            <img
              src={image}
              alt={alt}
              loading="lazy"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </section>
);

export default ScheduleSection;
